module.exports = __webpack_public_path__ + "img/weddings_27_V.4e0ae65e.webp";